<div class="impersonation-banner" *ngIf="isImpersonating">
  <div class="flexRow">
    <i class="vr-ic_fluent_person_sync_24_regular" style="opacity: 0.8"></i>
    <span class="impersonation-text">
    {{ 'IMPERSONATION.NAVIGATING_AS' | translate }}
      <strong style="opacity: 1">{{ displayName }}</strong>
    <ng-container *ngIf="displayEmail">  &middot;  {{ displayEmail }}</ng-container>
  </span>
  </div>
  <dx-button
    class="exit-button"
    [text]="'IMPERSONATION.EXIT' | translate"
    icon="runner"
    stylingMode="outlined"
    (onClick)="stopImpersonation()">
  </dx-button>
</div>
